import { Component } from "@angular/core"

@Component({
  standalone: false,
  selector: "app-calltoaction",
  templateUrl: "./calltoaction.component.html",
})
export class CalltoactionComponent {}
